import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { DashboardShellProvider } from '../context/DashboardShellContext';
import BaseDashboardLayout from './BaseDashboardLayout';
import { NAV_CONFIG, getVisibleNavSections } from '../components/Sidebar/navConfig';
import { buildDomainSections } from '../components/Sidebar/buildDomainSections';

const AdminLayout = () => {
  const { user, isAdmin } = useAuth();
  const baseNavSections = useMemo(() => getVisibleNavSections(NAV_CONFIG, { user, isAdmin }), [user, isAdmin]);
  const sections = useMemo(() => buildDomainSections(baseNavSections, 'admin'), [baseNavSections]);
  const shell = useMemo(
    () => ({
      homePath: '/admin/overview',
      workspacePath: '/admin/overview',
      profilePath: '/admin/profile',
      projectBasePath: null,
      codingRoot: '/admin',
      codingActivityPath: null,
    }),
    [],
  );

  return (
    <DashboardShellProvider value={shell}>
      <BaseDashboardLayout brandPath="/admin/overview" sections={sections}>
        <Outlet />
      </BaseDashboardLayout>
    </DashboardShellProvider>
  );
};

export default AdminLayout;
